import React from 'react';

import { useContactBar } from '../../utils/hooks/useContactBarHook';

const PaymentFailure: React.FC = () => {
  useContactBar();

  return (
    <p className="m-auto text-lg overflow-auto text-center">
      Your payment was not successful. Please try again.
    </p>
  );
};

export default PaymentFailure;
